import { useState, useEffect } from 'react';
import { sparePartService } from '../services';
import { SparePart } from '../interfaces/Item';

export const useFindEquivalentSpareParts = (
  id: string
): [SparePart[], boolean, boolean] => {
  const [items, setItems] = useState<SparePart[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    (async (): Promise<void> => {
      try {
        setIsLoading(true);
        setIsError(false);
        const result = await sparePartService.fetchSparePartId(id);
        setItems([result]);
      } catch {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [id]);
  return [items, isLoading, isError];
};
